/**
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "../common/namespaces";

export type * from "../lib/storage/types.js";

/**
 *
 */
export const storage: OttoGlobal["globalStorage"] = o_global.globalStorage;
